<template>
  <div class="mt-8">
    <px-view-module-header module-name="Cotações" :breadcrumbs="breadcrumbs"/>
    <v-card class="rounded-card card-shadow mt-8">
      <v-card-text class="text--primary">
        <px-view-header-title title="Vendas"/>
        <div class="mt-5">
          <px-listagem-vendas-header :on-click-refresh="onClickRefresh"
                                     @change="onChangeFilter"/>
          <px-lista-vendas :vendas="vendas" :loading="loading"
                           :on-change-options="onChangeOptions"
                           :options-list="optionsList"
                           @update="onClickRefresh"/>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import paginationMixin from '@/mixins/pagination-mixin';
import VendasListagemService from './vendas-service';
import ListagemVendasHeader from './ListagemVendasHeader.vue';
import ListaVendas from './ListaVendas.vue';

export default {
  mixins: [paginationMixin],
  data() {
    return {
      vendas: {
        content: [],
        total: 0,
      },
      listOptions: {
        page: 1,
        limit: 10,
        offset: 0,
        filter: '',
        sort: 'createdIn',
        sortDesc: true,
      },
      loading: false,
      breadcrumbs: [
        { text: 'Cotações' },
        { text: 'Vendas' },
      ],
      optionsList: {},
    };
  },
  computed: {
    ...mapGetters('listagemVendas', ['stringFilter']),
  },
  methods: {
    onChangeFilter() {
      this.listOptions.filter = this.stringFilter;
      this.resetPage();
      this.getVendas();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getVendas();
    },
    onClickRefresh() {
      this.getVendas();
    },
    resetPage() {
      this.listOptions = this.resetPagination(this.listOptions);
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getVendas() {
      this.loading = true;
      const {
        limit,
        offset,
      } = this.listOptions;
      return VendasListagemService.getVendas({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.vendas = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  components: {
    pxListagemVendasHeader: ListagemVendasHeader,
    pxListaVendas: ListaVendas,
  },
  created() {
    this.optionsList = this.pageToOptions(this.listOptions);
    this.listOptions.filter = this.stringFilter;
  },
};
</script>
